const passengers = {
  table: {
    headers: {
      createBtn: 'הוסף',
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      baseAddress: 'כתובת בית',
      alternateAddress: 'כתובת חלופית',
      occupationAddress: 'בית ספר',
      createdAt: 'נוצר בתאריך',
      profile: 'פרופיל',
    },
  },
};

export default passengers;
